export default __webpack_public_path__ + "static/media/abtres.e46cae8d.svg";